import React, { Fragment } from 'react';
import { config, useSpring } from 'react-spring';
import BurgerMenu from './BurgerMenu';
import './BurgerMenu.scss';
import CollapseMenu from './CollapseMenu';

const LandingNavbar = props => {
  const barAnimation = useSpring({
    from: { transform: 'translate3d(0, -10rem, 0)' },
    transform: 'translate3d(0, 0, 0)'
  });

  const linkAnimation = useSpring({
    from: { transform: 'translate3d(0, 30px, 0)', opacity: 0 },
    to: { transform: 'translate3d(0, 0, 0)', opacity: 1 },
    delay: 800,
    config: config.wobbly
  });
  return (
    <Fragment>
      <div className='navbar2' style={barAnimation}>
        <div className='d-flex p-2'>
          <div className='navlinks1' style={linkAnimation}>
            <a href='/login'> Login</a>
            <a href='/register'> Register</a>
          </div>
          <div className='burgerwrapper'>
            <BurgerMenu
              navbarState={props.navbarState}
              handleNavbar={props.handleNavbar}
            />
          </div>
        </div>
      </div>
      <CollapseMenu
        navbarState={props.navbarState}
        handleNavbar={props.handleNavbar}
      />
    </Fragment>
  );
};

export default LandingNavbar;
